import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { applicationResolver } from '@shared/resolvers/application.resolver';
import { ApplicationsComponent } from './applications/applications.component';
import { AuthComponent } from './auth.component';
import { authDataResolver } from './auth.resolver';
import { EmailVerificationComponent } from './email-verification/email-verification.component';

export const authRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild([
    {
        path: 'auth',
        component: AuthComponent,
        children: [
            {
                path: 'email-verification',
                data: {
                    pageName: "Email verification"
                },
                component: EmailVerificationComponent,
                resolve: {
                    application: applicationResolver
                }
            },
            {
                path: 'applications',
                data: {
                    pageName: "Pending applications"
                },
                component: ApplicationsComponent,
                resolve: {
                    authData: authDataResolver
                }
            }
        ]
    }
]);
